/**
 * Patient Create Page
 *
 * This page renders a breadcrumb navigation and the PatientCreateForm component.
 *
 * The orderId param is optional and is used to determine if the order is being created or edited.
 */
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import PatientCreateAddressForm from "./-address-form";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { PatientCrumbs } from "../../-crumbs";

export const Route = createFileRoute(
  "/_private/_patient-360/patient/$patientId/create/address",
)({
  component: PatientAddressCreatePage,
});

function PatientAddressCreatePage() {
  const { patientId } = Route.useParams();
  const navigate = useNavigate();

  const onSuccessFn = () => {
    navigate({
      to: "/patient/$patientId/create/patient-payor",
      params: { patientId },
    });
  };

  return (
    <div>
      <title>Patient Address - Legrande Health Portal</title>
      <PatientCrumbs />

      <Card>
        <CardHeader>
          <CardTitle>New Patient Address</CardTitle>
          <CardDescription>
            Enter patient address details below.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <PatientCreateAddressForm
            patientId={patientId}
            onSuccessFn={onSuccessFn}
            onCancelBtn={
              <Button variant="outline" asChild>
                <Link
                  to="/patient/$patientId/create/patient-payor"
                  params={{ patientId }}
                >
                  Skip
                </Link>
              </Button>
            }
          />
        </CardContent>
      </Card>
    </div>
  );
}
